// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"c9ffdcd8","260":"09e5936d","824":"b4061cce","965":"38d7e3db"}[chunkId] + ".chunk.js";
};